import styled from 'styled-components';

export const BookingSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing6};
`;
